const enUS = {
    testing: "testing en",
    testing2: {
        test: "testing nested en",
    },
    errors: {
        message:{
            400: "Bad Request",
            401: "Unauthorized",
            403: "Forbidden",
            404: "Not Found"
        }
    }
}

export default enUS